import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Title } from "../../themes/Default/components/Title";
import { Main } from "../../themes/Default/components/Main";
import { Button } from "../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../themes/Default/components/List";
import { Header as ListHeader } from "../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../themes/Default/components/List/components/Body";
import { Grid as ListGrid } from "../../themes/Default/components/List/components/Grid";
import { GroupCard } from "../../themes/Default/components/List/components/Grid/components/Card";
import { TableHead } from "../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Title as ListTitle } from "../../themes/Default/components/List/components/Header/components/Title";
import { GridLoader } from "./components/Loader";
import { Menu as ListMenu } from "../../themes/Default/components/List/components/Header/components/Menu";
import { Filter as ListFilter } from "../../themes/Default/components/List/components/Header/components/Filter";
import { Button as ListMenuButton } from "../../themes/Default/components/List/components/Header/components/Menu/components/Button";
import { groupsManagement } from "../../hooks/api/GroupsManagement";
import { Slide, toast, ToastContainer } from "react-toastify";
import { getNumberOfUsedFilters } from "../../services/utils/Filter";
import { Formik } from "formik";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../themes/Default/components/Form/components/Input";
import { Pagination } from "../../themes/Default/components/List/components/Footer/components/Pagination";
import { Checkbox } from "../../themes/Default/components/Form/components/Checkbox";
import { Toaster } from "../../themes/Default/components/Toaster";
import CambridgeIcon from "../../assets/icons/Cambridge icon.svg";
import JuniorIcon from "../../assets/icons/Junior icon.svg";
import KidsBoxIcon from "../../assets/icons/Kids Box icon.svg";
import SuperSafariIcon from "../../assets/icons/Super Safari icon.svg";
import { roles } from "../../services/utils/Roles";
import { useUserToken } from "../../hooks/core/UserToken";
import { isGridView } from "../../services/core/User/IsGridView";
import { Select } from "../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../services/core/Select";
import { employeesManagement } from "../../hooks/api/EmployeesManagement";
import { languageProgramsManagement } from "../../hooks/api/LanguageProgramsManagement";
import { locationsManagement } from "../../hooks/api/LocationsManagement";
import TimePicker from "../../themes/Default/components/Form/components/TimePicker/TimePicker";
import { languagesManagement } from "../../hooks/api/LanguagesManagement";
import DatePicker from "../../themes/Default/components/Form/components/DatePicker/DatePicker";
import { usePersistentFilters } from "../../hooks/core/PersistentFilters";
import { settingsCallManagement } from "../../hooks/api/SettingsCallManagement";

const Groups = () => {
    const { t } = useTranslation("common");
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const recordsPerPage = 300;
    const defaultFilters = {
        startPage: 0,
        limitPage: recordsPerPage,
        name: "",
    };
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [filters, setFilters, resetFilters] = usePersistentFilters("groupsFilters", defaultFilters);
    const [currentPage, setCurrentPage] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [disableDelete, setDisableDelete] = useState(true);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [numberOfUserdFilters, setNumberOfUserdFilters] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [groups, setGroups] = useState();
    const { useGroupsListMutation, useDeleteGroupMutation, useExportGroupsMutation } = groupsManagement;
    const [groupsList, { isLoading }] = useGroupsListMutation();
    const [exportGroups] = useExportGroupsMutation();
    const [deleteGroup] = useDeleteGroupMutation();
    const [isGridActive, setIsGridActive] = useState(isGridView(decodedToken, "groups"));
    const { useEmployeesListMutation } = employeesManagement;
    const [professorList] = useEmployeesListMutation();
    const [professors, setProfessors] = useState([]);
    const [languagePrograms, setLanguageProgram] = useState([]);
    const { useProgramListMutation } = languageProgramsManagement;
    const [languageProgramList] = useProgramListMutation();
    const [locations, setLocations] = useState([]);
    const { useLocationListMutation } = locationsManagement;
    const [locationList] = useLocationListMutation();
    const [classDuration, setClassDuration] = useState([]);

    const { useLanguageListMutation } = languagesManagement;
    const [languageList] = useLanguageListMutation();
    const [languages, setLanguages] = useState([]);    

    const [appointment, setAppointment] = useState([]);
    const { useAppointmentListMutation } = settingsCallManagement;
    const [appointmentList] = useAppointmentListMutation();

    const weekDays = ["PON", "UTO", "SRE", "ČET", "PET", "SUB", "NED"];
    const [selectedWeekdays, setSelectedWeekdays] = useState([]);
    const weekDaysForFilter = ["P", "U", "S", "Č", "P", "S", "N"];
    const toggleWeekday = (dayIndex) => {
        setSelectedWeekdays((prev) => (prev.includes(dayIndex) ? prev.filter((d) => d !== dayIndex) : [...prev, dayIndex]));
    };

    const openFilter = () => {
        setShowFilter(true);
    };

    const closeFilter = () => {
        setShowFilter(false);
    };

    const gotoNew = () => {
        navigate("/groups/add");
    };

    const gotoEdit = (groupId) => {
        navigate("/groups/edit/" + groupId);
    };

    const gotoAttendance = (groupId) => {
        navigate("/groups/" + groupId + "/attendance");
    };

    const handleGridView = () => {
        setIsGridActive(!isGridActive);
    };

    const onFilter = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onFiltered = (values) => {
        const newFilters = {
            ...filters,
            name: values.name,
            isArchived: values.isArchived,
            hasStarted: values.hasStarted,
            professor: values.professor,
            studentNumber: values.studentNumber,
            location: values?.location,
            languageProgram: values?.languageProgram,
            language: values?.language,
            classStartTime: values?.classStartTime,
            classDuration: values?.classDuration,
            firstDate: values?.firstDate,
            appointment: values.appointment,
        };

        if (selectedWeekdays.length > 0) {
            newFilters.weekDays = selectedWeekdays;
        } else {
            delete newFilters.weekDays; 
        }

        setFilters(newFilters);
    };

    const onPageChange = (currentPage) => {
        setCurrentPage(currentPage);
        const newStartPage = (currentPage - 1) * recordsPerPage;
        setFilters({
            ...filters,
            startPage: newStartPage,
            limitPage: recordsPerPage,
        });
    };

    const onSelectionChange = (id) => {
        setSelectedGroups((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedGroups?.length; i++) {
                            const groupId = selectedGroups[i];
                            deleteGroup(groupId).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    groupsList(filters).then((result) => {
                                        const groups = result?.data?.records;
                                        setGroups(groups);
                                        setTotalRecords(result?.data?.totalRecords);
                                    });
                                    setDisableDelete(true);
                                    toast.info(result?.data?.info?.responseMessage);
                                    onSelectionChange(groupId);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onExport = async () => {
        const blob = await exportGroups().unwrap();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const today = new Date().toISOString().split("T")[0];
        link.download = `Groups_${today}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const getUrl = (typeIcon) => {
        switch (typeIcon) {
            case "ICON_JUNIOR":
                return SuperSafariIcon;
            case "ICON_KIDS_BOX":
                return JuniorIcon;
            case "ICON_SUPER_SAFARI":
                return KidsBoxIcon;
            case "ICON_CAMBRIDGE":
                return CambridgeIcon;
            default:
                return "";
        }
    };

    const truncateWithTooltip = (text, maxLength = 25) => {
        if (!text) return "";
        const shouldTruncate = text.length > maxLength;
        const truncated = shouldTruncate ? text.slice(0, maxLength) + "..." : text;

        return <span title={shouldTruncate ? text : ""}>{truncated}</span>;
    };

    useEffect(() => {
        if (selectedGroups.length > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
    }, [selectedGroups]);

    const classDurations = () => {
        const options = [
            { id: 45, name: "45" },
            { id: 55, name: "55" },
            { id: 60, name: "60" },
            { id: 75, name: "75" },
            { id: 90, name: "90" },
            { id: 120, name: "120" }
        ];
    
        return prepareSelect(options);
    };

    useEffect(() => {
        groupsList(filters).then((result) => {
            const groups = result?.data?.records;
            setGroups(groups);
            setTotalRecords(result?.data?.totalRecords);
        });
        setNumberOfUserdFilters(getNumberOfUsedFilters(filters));
        professorList({ role: "ROLE_PROFESSOR" }).then((result) => {
            let options = [];
            result?.data?.records.map((professor) => {
                options.push({
                    id: professor.id,
                    name: professor.firstName + " " + professor.lastName,
                });
            });
            setProfessors(prepareSelect(options));
        });

        languageProgramList().then((result) => {
            let options = [];
            result?.data?.records.map((program) => {
                options.push({
                    id: program.id,
                    name: program.name + " - " + program.languageName,
                });
            });
            setLanguageProgram(prepareSelect(options));
        });
        locationList().then((result) => {
            setLocations(prepareSelect(result?.data?.records));
        });

        languageList().then((result) => {
            setLanguages(prepareSelect(result?.data?.records));
        });

        appointmentList().then((result) => {
            let options = [];
            result?.data?.records.map((appointment) => {
                options.push({
                    id: appointment.id,
                    name: appointment.name,
                });
            });
            setAppointment(prepareSelect(options));
        });

        setClassDuration(classDurations); 
    }, [filters, groupsList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES) || decodedToken?.roles.includes(roles.SECRETARY)) && (
                    <>
                        <Button title={t("groups.addGroup")} icon="fa-regular fa-plus" onClick={gotoNew} />
                        <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={disableDelete} onClick={onDelete} />
                    </>
                )}
                {(decodedToken?.roles.includes(roles.SUPER_ADMIN) ||
                    decodedToken?.roles.includes(roles.ROLE_DIRECTOR) ||
                    decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)) && (
                    <>
                        <Button title={t("export")} icon="fa-regular fa-cloud-arrow-down" onClick={onExport}></Button>
                    </>
                )}
            </TopNavigation>
            <Main>
                <Title>{t("groups.title")}</Title>
                <Breadcrumps>
                    <Link title={t("groups.title")} icon="fa-light fa-users" />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                {!isLoading ? (
                    <>
                        <List isGridActive={isGridActive}>
                            <ListHeader>
                                <ListTitle title={`${t("groups.title")} (${totalRecords})`} subtitle="Equilibrio Kids and Teens" />
                                <ListMenu>
                                    <ListMenuButton
                                        title={isGridActive ? "List view" : "Card view"}
                                        icon={isGridActive ? "fa-list-ul" : "fa-grid-2"}
                                        onClick={handleGridView}
                                    />
                                    <ListMenuButton title="Filter" icon="fa-filter" onClick={openFilter} badge={numberOfUserdFilters} />
                                </ListMenu>
                                <ListFilter isVisible={showFilter} onClose={closeFilter} onFilter={onFilter} onResetFilter={resetFilters}>
                                    <Formik
                                        innerRef={formRef}
                                        initialValues={{
                                            name: filters?.name,
                                            hasStarted: filters?.hasStarted,
                                            professor: filters?.professor,
                                            studentNumber: filters?.studentNumber,
                                            location: filters?.location,
                                            languageProgram: filters?.languageProgram,
                                            language: filters?.language,
                                            weekDays: selectedWeekdays,
                                            classStartTime: filters?.classStartTime ?? "",
                                            classDuration: filters?.classStartTime,
                                            firstDate: filters?.firstDate,
                                            appointment: filters?.appointment,
                                        }}
                                        onSubmit={onFiltered}
                                    >
                                        {({ values, handleChange, handleSubmit, resetForm, setFieldValue }) => (
                                            <Form>
                                                <Row>
                                                    <Field>
                                                        <Input name="name" label={t("groups.name")} value={values.name} onChange={handleChange} />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="location"
                                                            label={t("groups.location")}
                                                            onChange={handleChange}
                                                            options={locations}
                                                            value={values.location}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="language"
                                                            label={t("groups.language")}
                                                            onChange={handleChange}
                                                            options={languages}
                                                            value={values.language}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                {/* <Row>
                                                    <Field>
                                                        <Select
                                                            name="languageProgram"
                                                            label={t("groups.languageProgram")}
                                                            onChange={handleChange}
                                                            options={languagePrograms}
                                                            value={values.languageProgram}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row> */}
                                                <Row>
                                                    <Field>
                                                        <Input
                                                            name="studentNumber"
                                                            label={t("groups.studentNumber")}
                                                            value={values.studentNumber}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="professor"
                                                            label={t("groups.professor")}
                                                            onChange={handleChange}
                                                            options={professors}
                                                            value={values.professor}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="hasStarted"
                                                            label={t("groups.hasStarted")}
                                                            options={prepareSelect([
                                                                { id: "true", name: t("students.canBePhotographedYes") },
                                                                { id: "false", name: t("students.canBePhotographedNo") },
                                                            ])}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            selectedValue={values.hasStarted}
                                                            searchVisible={false}
                                                        />
                                                    </Field>
                                                </Row>
                                                {/* <Row>
                                                    <Field>
                                                        <TimePicker
                                                            name="classStartTime"
                                                            label={t("groups.classStartTime")}
                                                            value={values.classStartTime}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <DatePicker
                                                            name="firstDate"
                                                            label={t("groups.startDate")}
                                                            value={values.firstDate ?? ""}
                                                            onChange={handleChange}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <Select 
                                                            name="classDuration" 
                                                            label={t('groups.classDuration')}
                                                            onChange={handleChange} 
                                                            options={classDuration} 
                                                            selectedValue={values.classDuration}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row> */}
                                                <Row>
                                                    <Field>
                                                        <Select
                                                            name="appointment"
                                                            label={t("groups.classStartTime")}
                                                            options={appointment}
                                                            onChange={handleChange}
                                                            selectedValue={values.appointment}
                                                            searchInDropdown={false}
                                                        />
                                                    </Field>
                                                </Row> 
                                                <Row>
                                                    <Field>
                                                        <Checkbox
                                                            name="isArchived"
                                                            label={t("groups.isArchived")}
                                                            checked={values.isArchived}
                                                            onChange={(e) => setFieldValue("isArchived", e.target.checked)}
                                                        />
                                                    </Field>
                                                </Row>
                                                <Row>
                                                    <Field>
                                                        <div className="bulkCalendar__label">Kombinacija dana</div>
                                                        <div className="bulkCalendar__days">
                                                            {weekDaysForFilter.map((dayLabel, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`bulkCalendar__day ${index >= 5 ? "weekend" : ""} ${selectedWeekdays.includes(index) ? "active" : ""}`}
                                                                    onClick={() => toggleWeekday(index)}
                                                                >
                                                                    {dayLabel}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Field>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </ListFilter>
                            </ListHeader>
                            {isGridActive ? (
                                <ListGrid>
                                    {groups?.length > 0 &&
                                        groups?.map((group) => {
                                            const days = group?.weekDays?.map((day) => weekDays[day]).join(", ");
                                            return (
                                                <GroupCard
                                                    key={group.id}
                                                    weekDays={days + " - " + group.classStartTime}
                                                    groupIsArchived={group.isArchived}
                                                    groupName={truncateWithTooltip(group.studentName ? group.studentName + " - " + group.name : group.name)}
                                                    groupColor={group.typeColor}
                                                    isSubstitute={group.isSubstitute}
                                                    icon={getUrl(group.typeIcon)}
                                                    professorName={group.professorFullName}
                                                    groupHasStarted={group.hasStarted}
                                                    onEditClick={() => gotoEdit(group.id)}
                                                    onAttendanceClick={() => gotoAttendance(group.id)}
                                                />
                                            );
                                        })}
                                </ListGrid>
                            ) : (
                                <ListBody>
                                    <TableHead>
                                        <TableRow>
                                            <TableHeadCell></TableHeadCell>
                                            <TableHeadCell></TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.location")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.classStartTime")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.language")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.weekDays")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.professor")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.studentNumber")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell>
                                                <span>{t("groups.hasStarted")}</span>
                                            </TableHeadCell>
                                            <TableHeadCell></TableHeadCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {groups?.length > 0 &&
                                            groups?.map((group) => {
                                                const days = group?.weekDays?.map((day) => weekDays[day]).join(", ");
                                                const days2 = group?.weekDays2?.map((day) => weekDays[day]).join(", ");

                                                return (
                                                    <TableRow key={group.id}>
                                                        <TableDataCell>
                                                            {group.hasStarted ? (
                                                                <Button
                                                                    icon="fa-regular fa-eye"
                                                                    onClick={() => gotoAttendance(group.id)}
                                                                    color="#27ae60"
                                                                ></Button>
                                                            ) : (
                                                                <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(group.id)}></Button>
                                                            )}
                                                        </TableDataCell>
                                                        <TableDataCell>
                                                            {(decodedToken?.roles.includes(roles.SUPER_ADMIN) || decodedToken?.roles.includes(roles.DIRECTOR_OF_STUDIES)) && (
                                                                <>
                                                                    <Checkbox name="isBlockClass" value={group.id} onChange={() => onSelectionChange(group.id)} />
                                                                </>
                                                            )}
                                                        </TableDataCell>
                                                        <TableDataCell>{group.locationName}</TableDataCell>
                                                        <TableDataCell>{group.classStartTime + (group.classStartTime2 ? " | " + group.classStartTime2 : "")}</TableDataCell>
                                                        <TableDataCell>{group.languageName}</TableDataCell>
                                                        <TableDataCell>{days + (days2 ? " | " + days2 : "")}</TableDataCell>
                                                        <TableDataCell>{group.professorFullName}</TableDataCell>
                                                        <TableDataCell>
                                                            <span style={{ color: group.studentNumber < group.minStudents ? '#ff0000' : '#27ae60' }}>
                                                                {group.studentNumber}
                                                            </span>
                                                            /
                                                            <span style={{ color: group.studentNumber > group.maxStudents ? '#ff0000' : '#27ae60' }}>
                                                                {group.maxStudents}
                                                            </span>
                                                        </TableDataCell>
                                                        <TableDataCell>{group.hasStarted ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}</TableDataCell>
                                                        <TableDataCell></TableDataCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </ListBody>
                            )}
                        </List>
                        <Pagination currentPage={currentPage} recordsPerPage={recordsPerPage} totalRecords={totalRecords} onClick={onPageChange} />
                    </>
                ) : (
                    <>
                        <GridLoader />
                    </>
                )}
            </Main>
        </DefaultLayout>
    );
};

export default Groups;
